// Override React Native's asset resolution for `Image` components
import { Asset } from 'expo-asset';
import Constants from 'expo-constants';
import * as FileSystem from 'expo-file-system';

export { Asset, Constants, FileSystem };
